import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const HelpButton = styled.button`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	user-select: none;
	position: fixed;
	right: 0;
	width: 40px;
	height: 14rem;
	background-color: var(--blue);
	cursor: pointer;
	border: none;
	border-radius: 4px 0 0 4px;
	padding: 2rem 1rem;
	z-index: var(--z-index-8);

	:hover,
	:focus {
		animation: bounceHelp 1s ease;
		background-color: var(--blue-hover);

		div > .dragIcon {
			display: block;
		}
	}

	body[dir='rtl'] & {
		right: unset;
		left: 0;
		border-radius: 0 4px 4px 0;
	}

	@keyframes bounceHelp {
		0% {
			transform: scale(1, 1) translate(0px, 0px);
		}

		30% {
			transform: scale(1, 0.8) translate(3px, 0px);
		}

		75% {
			transform: scale(1, 1.1) translate(0px, 0px);
		}

		100% {
			transform: scale(1, 1) translate(0px, 0px);
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		width: 5rem;
		height: 8rem;
	}
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 1rem;
	transform: rotate(-90deg);

	body[dir='rtl'] & {
		transform: rotate(90deg);
	}

	@media ${Breakpoints.mobileLandscape} {
		> .icon {
			transform: rotate(90deg);
		}
	}
`;

export const LightIcon = styled(Icon)`
	display: none;
	transform: rotate(90deg);
	opacity: 0.7;
`;

export const NotificationBadge = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	background-color: var(--red);
	border-radius: 50%;
	position: absolute;
	top: -0.75rem;
	left: -0.75rem;
	transform: rotate(-90deg);

	body[dir='rtl'] & {
		left: unset;
		right: -0.75rem;
		transform: rotate(90deg);
	}
`;
